import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { AlertRel } from 'Views/Authentication/Components/AlertRel';

export const ContactSupportAlert = () => {
  const { resource } = useMetaLayoutContext();

  return resource.withRelationship(
    fr.relationships.contactSupport.name,
    (rel) => {
      return (
        <AlertRel
          relationship={rel}
          href={rel.link('related').url()}
        />
      );
    },
    () => null,
  );
};
